<template>
  <div class="flex w-[272px] flex-col gap-3 p-5">
    <div class="flex flex-col gap-1">
      <p class="text-[16px] font-semibold tracking-[-0.32px] leading-5 text-lavender">
        {{ t('header.balance.powerMiles') }}
      </p>
      <p class="text-[14px] font-semibold tracking-[-0.28px] leading-5 text-purple-gray">
        {{ t('header.balance.powerMilesDescription') }}
      </p>
    </div>

    <div class="h-px bg-white/8" />

    <div class="grid grid-cols-[18px_1fr] items-center gap-3">
      <Flame class="size-[18px] self-center text-orange2" />
      <p class="text-[14px] font-semibold leading-5 tracking-[-0.28px] text-purple-gray">
        <span class="text-orange2">{{ burnTitle }}</span>
        <span> — {{ t('powerMilesBurnReminder.shortBody') }}</span>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Flame } from 'lucide-vue-next'
import { usePowerMilesBurnReminder } from '@/composables/use-power-miles-burn-reminder'
import { useTranslation } from '@/composables/use-i18n'

const { t } = useTranslation()
const { burnTitle } = usePowerMilesBurnReminder()
</script>
